export default __webpack_public_path__ + "assets/images/aistudio/views/ebe07609d8b32f8a8d50d076b4a9cea2.png";